/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { Link, useParams } from "react-router-dom";
import { useInvoice } from "../lib/react-query/useInvoice";
import LoadingIndicator from "../components/LoadingIndicator";
import InvoiceCard from "../components/InvoiceCard";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import Button from "../components/ui/Button";
import Icon from "../components/ui/Icon";
import styled from "styled-components";
import T from "../components/ui/Translation";
import InvoicePackageInstances from "../components/booking/checkout/InvoicePackageInstances";
import Flex from "../components/ui/Flex";
import SkeletonText from "../components/skeleton/SkeletonText";

const StyledLink = styled((props) => <Link {...props} />)`
  display: inline-block;
  margin-top: 2rem;
`;

const InvoiceDetails = () => {
  const { id } = useParams();
  const { isLoading, data: invoice } = useInvoice(id);

  if (isLoading) {
    return (
      <Container>
        <NavigationHeader title={<SkeletonText size="h3" width="8rem" />} back={-1} />
        <LoadingIndicator page />
      </Container>
    );
  }

  return (
    <Container>
      <NavigationHeader
        title={
          <>
            <T>offer #</T> {invoice.number}
          </>
        }
        back={-1}
      />
      <Flex $direction="column" $justify="space-between" $gap="1rem">
        <InvoicePackageInstances invoice={invoice} />
        <InvoiceCard invoice={invoice} />
      </Flex>
      {invoice.print_link && (
        <StyledLink to={invoice.print_link} target="_blank">
          <Button variant="primary" title="print" icon={<Icon.Print size={Icon.SIZE.SM} />} />
        </StyledLink>
      )}
    </Container>
  );
};

export default InvoiceDetails;
